import React from "react";
import { InputAdornment, TextField, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";

const CLEAR_SEARCH_KEYS = ["Enter", " "];

// Pins the picker dialog's width so it doesn't resize while the search filter
// changes how many rows are shown. Pass as the Dialog's PaperProps.
export const TEMPLATE_PICKER_PAPER_PROPS = { className: "template-picker-paper" };

// Search box shown above the list in every template picker, with a clear (x) button
// that is only present once there is text to clear.
export const TemplateSearchField = ({ searchQuery, onSearchQueryChange }) => {
  const clearSearch = () => onSearchQueryChange("");

  return (
    <TextField
      className="template-search-input"
      fullWidth
      placeholder="Search templates"
      value={searchQuery}
      onChange={(e) => onSearchQueryChange(e.target.value)}
      inputProps={{ "aria-label": "Search templates" }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
        endAdornment: searchQuery ? (
          <InputAdornment position="end">
            <CloseIcon
              className="template-search-clear-icon"
              role="button"
              tabIndex={0}
              aria-label="Clear search"
              aria-hidden={false}
              onClick={clearSearch}
              onKeyDown={(e) => CLEAR_SEARCH_KEYS.includes(e.key) && clearSearch()}
            />
          </InputAdornment>
        ) : null,
      }}
    />
  );
};

export const TemplateSearchEmptyState = () => (
  <div className="template-search-empty">
    <Typography>No templates found</Typography>
  </div>
);
